import testPodcast from "../../music/Test Podcast_mixdown1.mp3";
import testPodcast1 from "../../music/LTT-Unplugged.mp3";

const episodes = [
  {
    id: 1,
    title: "Podcasting Essentials: The Beginner's Kit",
    date: "26 June, 2025",
    description:
      "Welcome to <span> 'Podcasting Essentials: The Beginner's Kit' </span> on L&TT Unplugged. Hosted by <span>Ankita</span>, this podcast is your go-to resource to start your own podcast. Whether you're a curious beginner or an aspiring podcaster, this series will provide a comprehensive guide on recording, publishing and promoting your podcast show.",
    guestInfo:
      "Join Ankita and our respected guest, <span> Shankar</span>, a Subject Matter Expert in Marketing and Branding from LX - L&TT ATCI, as they share tips, industry insights, and creative strategies to help you navigate the podcasting landscape with confidence. Tune in to our 1st episode, <span>'Podcasting Essentials: The Beginner's Kit'</span>, and embark on an exciting podcasting journey.",
    image: "images/Podcast/album_cover_img3.png",
    duration: "00:08:30 / 00:11:21",
    fileSize: "13.9 MB",
    audioSrc: testPodcast1,
  },
  {
    id: 2,
    title: "Lorem Ipsum is simply dummy text of the",
    date: "",
    description: "Lorem Ipsum has been the industry's standard dummy text...",
    image: "images/Podcast/album_cover_img2.png",
    fileSize: "38.69 MB",
    audioSrc: testPodcast,
  },
  {
    id: 3,
    title: "Lorem Ipsum is simply dummy text of the",
    date: "",
    description: "Lorem Ipsum has been the industry's standard dummy text...",
    image: "images/Podcast/album-cover.png",
    fileSize: "38.69 MB",
    audioSrc: testPodcast,
  },
];

export default episodes;
